import Text from './Text';
import { TextProps, TextValueProps, TextCombinedProps } from './types';

export type { TextProps, TextValueProps, TextCombinedProps };
export default Text;
